import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatSidenavModule } from '@angular/material/sidenav';
import { RouterModule, RouterOutlet, Router } from '@angular/router';
import { TeacherSidenavbarComponent } from '@edtech-ui/dashboard/teacher/teacher-navbar/teacher-sidenavbar/teacher-sidenavbar.component';
import { RecruiterSidebarComponent } from '../../hiring-workspace/recruiter-dashboard/components/recruiter-sidebar/recruiter-sidebar.component';
import { AuthServiceService } from '@edtech-ui/core/services/authService/auth-service.service';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { finalize, tap } from 'rxjs/operators';

@Component({
  selector: 'app-admin-student-platform-layout',
  standalone: true,
  imports: [CommonModule,
    FormsModule,
    MatSidenavModule,
    RouterOutlet,
    RouterModule,
    TeacherSidenavbarComponent,
    RecruiterSidebarComponent],
  templateUrl: './admin-student-platform-layout.component.html',
  styleUrl: './admin-student-platform-layout.component.scss'
})
export class AdminStudentPlatformLayoutComponent {
  collapsed: boolean = false;
  isCompanyAdmin: boolean = false;
  activeTab: string = 'jobs';
  subscription = new Subscription();

  constructor(
    private router: Router,
    private _authService: AuthServiceService,
    private _toastr: ToastrService
  ) {
    const roleId = localStorage.getItem('role_id');
    if (roleId === '8' || roleId === '14' ||  roleId === 'COMPANYADMIN') {
      this.isCompanyAdmin = true;
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  toggleSidenav() {
    this.collapsed = !this.collapsed;
  }

  setActiveTab(tab: string) {
    this.activeTab = tab;
    if (['dashboard', 'jobs', 'candidates', 'assessments', 'company-profile'].includes(tab)) {
      this.router.navigate([`/recruiter-dashboard/${tab}`]);
    }
  }

  logout() {
    this.subscription.add(
      this._authService.logout(this.router).subscribe()
    );
  }
}
